export enum SliderStates {
  SLIDER_ACTIVE   = 'SLIDER_ACTIVE',
  SLIDER_INACTIVE = 'SLIDER_INACTIVE'
}
